import React from 'react';
import { connectStats } from 'react-instantsearch-dom';

interface Props {
  nbHits: number,
}

const NumberHits: React.FC<Props> = ({
  nbHits,
}) => (
  <p className="m-0">{nbHits}</p>
);

export default connectStats(NumberHits);
